import React, { Component } from "react";
import Api from "../../../../Services/Api";
import API from "../../../../Services/Api";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables-bitozen";

import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import { checkResponseError } from "../../../../Services/Utils";
import SimpleSearch from "../../../../modules/SimpleSearch";
import EmployeeSearchForm from "./searchEmployee";
import DDLParamValue from "../../../../modules/commons/DDLParamValue";
import FormEditRole from "../role/formEditRole";
import NormalInput from "../../../../modules/NormalInput";
import SimpleTextArea from "../../../../modules/simpleTextArea";
import Button from "../../../../modules/commons/Button";

const CryptoJS = require("crypto-js");

const ct = require("../../../../modules/custom/customTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptions6();

class FormPart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data
        ? props.data
        : {
            userId: null,
            companyGroupId: null,
            companyId: null,
            categoryId: null,
            username: null,
            password: null,
            email: null,
            status: "Active",
            status2: "Import",
            status3: "Active",
            emplId: null,
            name: "",
            action: "NEW",
            kecamatan: null,
            kota: null,
            provinsi: null,
            alamat: null,
            ahassdealercode: null,
            dealercode: null,
            image: null,
            dealername: null,
            description: null,
          },
      name: "",
      detailVisible: false,
      disableName: false,
      category: null,
      employeeSearchFormVisible: false,
      createVisible: false,
      loadSave: false,
      savePopUpVisible: false,
      deletePopUpVisible: false,
      companyData: [],
      dataRole: [],
      dataTable: [],
      countDataRole: 0,
      table_limit: 10,
      table_page: 0,
      table_query: "",

      confirmPassVisible: false,
      PassVisible: false,

      maindealername: [
        { label: "Daya" },
        { label: "Wahana" },
        { label: "Jopras" },
      ],

      provinsi: [
        { label: "Jawa Barat" },
        { label: "Jawa Tengah" },
        { label: "Jawa Timur" },
      ],

      kota: [{ label: "Semarang" }, { label: "Solo" }, { label: "Jakarta" }],

      kecamatan: [
        { label: "Bendungan Hilir" },
        { label: "Jombang" },
        { label: "Kuninngan" },
      ],
    };
  }

  showPassword = (type) => {
    switch (type) {
      case "pass":
        this.setState({ PassVisible: !this.state.PassVisible });
        break;
      case "confirm":
        this.setState({ confirmPassVisible: !this.state.confirmPassVisible });
        break;
      default:
        break;
    }
  };

  componentDidMount() {
    this.getCompanyDdl();
    if (this.props.type !== "create") {
      this.setDataValue(this.state.data);
      this.getRole(this.state.table_page, this.state.table_limit);
      // console.log(JSON.stringify(this.state.data, null, 2))
    }
  }

  setDataValue(data) {
    let dataCompany = {
      value: data.companyId,
      label: data.companyName,
    };

    let dataUserCategory = {
      value: data.categoryId,
      label: data.category,
    };

    this.setState({
      data: {
        ...this.state.data,
        categoryIdSelect: dataUserCategory,
      },
      companyIdSelect: dataCompany,
      name: data.name,
      category: data.category,
      disableName: data.category === "Non Employee & Outsource" ? false : true,
    });
  }

  getCompanyDdl() {
    let payload = {
      companyGroupId: "TAB",
    };
    Api.create("MASTERDATA_EKSAD")
      .postGetCompanyDdl(payload)
      .then((res) => {
        if (res.ok && res.data.status === "S") {
          let array = [];
          res.data.data &&
            res.data.data.map((item) => {
              array.push({
                value: item.companyId,
                label: item.companyName,
              });
            });
          this.setState({
            companyData: array,
          });
        }
      });
  }

  getRole = async (page, limit) => {
    let payload = {
      limit: limit,
      offset: page,
      roleName: this.state.table_query,
      userId: this.state.data.userId,
    };
    let res = await API.create("MASTERDATA_EKSAD").postGetUserRole(payload);
    if (res.ok) {
      if (res.data.data === null) {
        this.setState({ dataTable: [] });
      } else {
        let dataTable =
          res.data.data &&
          res.data.data.listRole.map((value) => {
            const { roleCode, roleName, accessType } = value;
            return [roleCode, roleName, accessType];
          });
        this.setState({
          dataRole: res.data.data && res.data.data.listRole,
          dataTable,
          countDataRole: res.data.data && res.data.data.dataOfRecord,
        });
        this.onFinishFetch();
      }
    }
  };

  validation(data) {
    if (!this.state.data.username) {
      return alert("Username is mandatory.");
    }
    if (!this.state.data.name) {
      return alert("Name is mandatory.");
    }
    if (!this.state.data.categoryId) {
      return alert("User Category is mandatory.");
    }
    if (this.state.data.categoryId === 3 && this.state.name === "") {
      return alert("Employee is mandatory.");
    }
    if (this.state.data.password !== this.state.data.confirmPassword) {
      return alert("Password dengan Confirm Password is not same.");
    }
    if (this.state.data.categoryId === "3" && !this.state.data.email) {
      return alert("Email is mandatory");
    }

    var pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    if (this.state.data.email && !pattern.test(this.state.data.email)) {
      return alert("Email is not valid");
    }

    if (this.props.type !== "create") {
      this.isLoad(true);
      this.setState(
        {
          data: {
            ...this.state.data,
            action: "EDIT",
          },
        },
        () => {
          this.onClickSave();
        }
      );
    } else {
      this.onClickSave();
    }
  }

  onClickSave = () => {
    this.state.data.password = CryptoJS.MD5(
      this.state.data.password
    ).toString();

    Api.create("LOCAL_CABANG")
      .postCabang(this.state.data)
      .then((res) => {
        if (res.ok && res.data.status === "S") {
          this.isLoad(false);
          this.props.onClickClose();
          this.props.onClickSave(res);
        } else {
          this.isLoad(false);
          this.props.onClickSave(res);
        }
      });
  };

  onchangeInput = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    this.setState({
      data: {
        ...this.state.data,
        [name]: value,
      },
    });
  };

  onChangeCombo = (event, name) => {
    let value = event.value;
    this.setState({
      data: {
        ...this.state.data,
        [name]: value,
      },
    });
  };

  opSidePage = (menu, data) => (e) => {
    e.preventDefault();
    let selectedIndex = data;

    switch (menu) {
      case "slide-menu-view":
        this.setState({
          detailVisible: true,
          selectedIndex,
          popupType: "view",
        });
        break;
      default:
        break;
    }
  };

  onFinishFetch = () => {
    if (typeof this.LoadingBar === "object") this.LoadingBar.complete();
  };

  openCreateForm = () => {
    this.setState({ createVisible: !this.state.createVisible });
  };

  handleSubmit = async (response) => {
    this.checkResponse(response);
  };

  isLoad(visible) {
    this.setState({ loadSave: visible });
  }

  checkResponse(res, type) {
    if (res.ok && res.data.status === "S") {
      type === "delete" && this.setState({ deletePopUpVisible: false });
      setTimeout(() => {
        this.openSavePopUp();
      }, 500);
    } else {
      this.isLoad(false);
      checkResponseError(res);
    }
  }

  openSavePopUp = () => {
    this.setState({
      savePopUpVisible: !this.state.savePopUpVisible,
      loadSave: false,
    });
  };

  openDetailForm = () => {
    this.setState({ detailVisible: !this.state.detailVisible });
  };

  openSearchEmployee = () => {
    if (
      this.props.type === "create" &&
      this.state.data.categoryId &&
      this.state.disableName
    ) {
      this.setState({
        employeeSearchFormVisible: !this.state.employeeSearchFormVisible,
      });
    }
  };

  handleChooseEmployee = async (response) => {
    console.log("Ini Data Employee : " + JSON.stringify(response, null, 2));
    this.setState({
      data: {
        ...this.state.data,
        name: response.emplName,
        emplId: response.emplId,
      },
      name: response.emplName,
    });
  };

  render() {
    return (
      <div>
        <div className="app-popup app-popup-show">
          <div className="padding-top-20px" />
          <div
            className="popup-content background-white border-radius"
            style={{ width: "70%" }}
          >
            <div className="popup-panel grid grid-2x">
              <div className="col-1">
                <div className="popup-title">{"FORM PARTS"}</div>
              </div>
              <div className="col-2 content-right">
                <button
                  className="btn btn-circle btn-grey"
                  onClick={this.props.onClickClose}
                >
                  <i className="fa fa-lg fa-times" />
                </button>
              </div>
            </div>
            <form
              action="#"
              onSubmit={(e) => {
                e.preventDefault();
                this.validation(this.state.data);
              }}
            >
              <div className="padding-15px grid grid-3x grid-mobile-none gap-15px">
                <div className="column-1">{this.renderForm()}</div>
                <div className="column-2">
                  {/*<div className="margin-5px">*/}
                  {/*    <div className="txt-site txt-11 txt-main txt-bold">*/}
                  {/*        <h4><span style={{color: 'red'}}>*format file (excel)</span></h4>*/}
                  {/*    </div>*/}
                  {/*</div>*/}
                  {this.renderForm2()}
                </div>
                <div className="column-3">{this.renderForm3()}</div>
              </div>
              {this.props.type !== "create" ? (
                <div className="padding-15px grid grid-1x grid-mobile-none gap-15px">
                  <div className="column-1">
                    <SimpleInput
                      required
                      label={"Position"}
                      name="position"
                      readOnly={true}
                      value={this.state.data.position}
                      onChange={this.onchangeInput}
                    />
                  </div>
                </div>
              ) : null}
              {this.props.type !== "create" ? (
                <div className="padding-15px grid grid-1x grid-mobile-none gap-15px">
                  <div className="column-1">{this.renderTable()}</div>
                </div>
              ) : null}
              {this.props.type !== "create" ? (
                <div className="margin-15px">
                  <label className="radio">
                    <input
                      type="checkbox"
                      disabled={this.props.type === "view"}
                      checked={this.state.isChangePassword}
                      onChange={(e) => {
                        this.setState({
                          isChangePassword: e.target.checked,
                        });
                      }}
                    />
                    <span className="checkmark" />
                    <div className="txt-site txt-11 txt-bold txt-main">
                      <h4>Change Password</h4>
                    </div>
                  </label>
                </div>
              ) : null}
              {this.state.isChangePassword && (
                <div className="padding-15px grid grid-2x grid-mobile-none gap-15px">
                  <div className="column-1">
                    {this.props.type !== "view" ? (
                      <div className="card-date-picker">
                        <div className="margin-5px">
                          <div className="txt-site txt-11 txt-main txt-bold">
                            <h4>
                              Password <span style={{ color: "red" }}>*</span>
                            </h4>
                          </div>
                        </div>
                        <div className="double margin-bottom-20px">
                          <input
                            type={this.state.PassVisible ? "text" : "passuord"}
                            className="input padding-15px"
                            required
                            onChange={(e) =>
                              this.setState({
                                data: {
                                  ...this.state.data,
                                  password: e.target.value,
                                },
                              })
                            }
                            value={this.state.data.password}
                          />
                          <button
                            type="button"
                            className="btn btn-grey border-left btn-no-radius"
                            onClick={this.showPassword.bind(this, "pass")}
                          >
                            <i
                              className={
                                this.state.PassVisible
                                  ? "fa fa-lg fa-eye"
                                  : "fa fa-lg fa-eye-slash"
                              }
                            />
                          </button>
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <div className="column-2">
                    {this.props.type !== "view" ? (
                      <div className="card-date-picker">
                        <div className="margin-5px">
                          <div className="txt-site txt-11 txt-main txt-bold">
                            <h4>
                              Confirm Password{" "}
                              <span style={{ color: "red" }}>*</span>
                            </h4>
                          </div>
                        </div>
                        <div className="double margin-bottom-20px">
                          <input
                            type={
                              this.state.confirmPassVisible
                                ? "text"
                                : "password"
                            }
                            className="input padding-15px"
                            required
                            onChange={(e) =>
                              this.setState({
                                data: {
                                  ...this.state.data,
                                  confirmPassword: e.target.value,
                                },
                              })
                            }
                            value={this.state.data.confirmPassword}
                          />
                          <button
                            type="button"
                            className="btn btn-grey border-left btn-no-radius"
                            onClick={this.showPassword.bind(this, "confirm")}
                          >
                            <i
                              className={
                                this.state.confirmPassVisible
                                  ? "fa fa-lg fa-eye"
                                  : "fa fa-lg fa-eye-slash"
                              }
                            />
                          </button>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              )}
              {this.state.isChangePassword && (
                <div className="padding-15px grid grid-1x grid-mobile-none gap-15px">
                  <div className="column-1">
                    <div className="txt-site txt-11 txt-main txt-bold">
                      <h4>
                        For a strong password, please use a hard to guess
                        combination of text with upper and lower case character,
                        symbols and numbers heheheehehe
                      </h4>
                    </div>
                  </div>
                </div>
              )}
              <div className="padding-15px">
                <div className="grid grid-2x">
                  <div className="col-1" />
                  <div className="col-2 content-right">
                    {this.props.type === "edit" ||
                    this.props.type === "create" ? (
                      <button
                        className="btn btn-red"
                        type="submit"
                        disabled={this.state.loadSave}
                      >
                        <span>
                          {!this.state.loadSave ? "SAVE" : "Saving..."}
                        </span>
                      </button>
                    ) : null}

                    <button
                      style={{ marginLeft: "15px" }}
                      className="btn btn-primary"
                      type="button"
                      onClick={this.props.onClickClose.bind(this)}
                    >
                      <span>CLOSE</span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
            <div>
              {this.state.employeeSearchFormVisible && (
                <EmployeeSearchForm
                  data={this.state.category}
                  stateData={this.state.data}
                  onClickClose={this.openSearchEmployee.bind(this)}
                  onChoose={this.handleChooseEmployee.bind(this)}
                  mandatory
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  columnRole = [
    "Role Code",
    "Role Name",
    {
      name: "Access Type",
      options: {
        customBodyRender: (val) => {
          return (
            <div
              style={{
                width: "90px",
                backgroundColor: val === "Allowed" ? "#00B9F2" : "red",
                borderRadius: 5,
                justifyContent: "center",
              }}
            >
              <div style={{ marginLeft: "20px", color: "white" }}>{val}</div>
            </div>
          );
        },
      },
    },
    this.props.type !== "view"
      ? {
          name: "Action",
          options: {
            customBodyRender: (val, tableMeta) => {
              return (
                <div style={{ width: "115px" }}>
                  <button
                    className="btnAct"
                    style={{ marginRight: 15, backgroundColor: "transparent" }}
                    onClick={this.opSidePage(
                      "slide-menu-view",
                      tableMeta.rowIndex
                    )}
                  >
                    <i
                      className="fa fa-lw fa-ellipsis-v"
                      style={{
                        backgroundColor: "transparent",
                        color: "#004c97",
                        fontSize: 20,
                      }}
                    />
                  </button>
                </div>
              );
            },
          },
        }
      : "",
  ];

  renderTable() {
    let { countDataRole, table_query } = this.state;
    let tableOptions = {
      ...options,
      serverSide: true,
      count: countDataRole,
      searchText: table_query,
      rowsPerPage: this.state.table_limit,
      page: this.state.table_page,
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.setState({ table_page: tableState.page });
            this.getRole(tableState.page, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.setState({ table_limit: tableState.rowsPerPage });
            this.getRole(tableState.page, tableState.rowsPerPage);
            break;
          case "search":
            let searchText = tableState.searchText ? tableState.searchText : "";
            this.setState({ table_query: searchText }, () => {
              this.getRole(tableState.page, tableState.rowsPerPage);
            });
            break;
          default:
            break;
        }
      },
    };
    return (
      <div>
        <MuiThemeProvider theme={getMuiTheme()}>
          <MUIDataTable
            key={countDataRole}
            title={"User Roles"}
            subtitle={"User Role List"}
            data={this.state.dataTable}
            columns={this.columnRole}
            options={tableOptions}
          />
        </MuiThemeProvider>
        {this.state.detailVisible && (
          <FormEditRole
            type={"view"}
            data={this.state.dataRole[this.state.selectedIndex]}
            formUser={true}
            loadSave={this.state.loadSave}
            onClickClose={this.openDetailForm.bind(this)}
          />
        )}
      </div>
    );
  }

  renderForm() {
    return (
      <div>
        <SimpleInput
          name="dealercode"
          label={"Part No"}
          value={this.state.data.dealercode}
          onChange={this.onchangeInput}
          // readOnly={this.props.type === "view" || this.state.disableName}
        />
        <SimpleInput
          name="ahassdealercode"
          label={"Nama Part"}
          value={this.state.data.ahassdealercode}
          onChange={this.onchangeInput}
          // readOnly={this.props.type === "view" || this.state.disableName}
        />
        <SimpleInput
          name="ahassdealercode"
          label={"Harga Jual / HET"}
          value={this.state.data.ahassdealercode}
          onChange={this.onchangeInput}
          // readOnly={this.props.type === "view" || this.state.disableName}
        />
        <SimpleInput
          name="ahassdealercode"
          label={"Harga Beli (Pokok)"}
          value={this.state.data.ahassdealercode}
          onChange={this.onchangeInput}
          // readOnly={this.props.type === "view" || this.state.disableName}
        />
        <dv>
          <input
            type="checkbox"
            style={{ marginLeft: "5px", marginRight: "5px" }}
          />
          <span>Hotline</span>
        </dv>
        <SimpleInput
          name="ahassdealercode"
          label={"Max HO QT"}
          value={this.state.data.ahassdealercode}
          onChange={this.onchangeInput}
          // readOnly={this.props.type === "view" || this.state.disableName}
        />
        <div className="padding-15px grid grid-7x grid-mobile-none gap-5px">
          <div className="column-1">
            <div className="margin-10px">
              <div className="txt-site txt-11 txt-main txt-bold">
                <h4>Parts:</h4>
              </div>
            </div>
          </div>
          <div className="column-2">
            <div className="margin-bottom-10px">
              <div className="margin-10px">
                <label className="radio">
                  <input
                    type="checkbox"
                    disabled={this.props.type === "view"}
                    checked={this.state.data.status2 === "Import"}
                    onChange={(e) => {
                      this.setState({
                        data: {
                          ...this.state.data,
                          status2: e.target.checked ? "Import" : "Local",
                        },
                      });
                    }}
                  />
                  <span className="checkmark" />
                  <div className="txt-site txt-11 txt-bold txt-main">
                    <h4>{this.state.data.status2}</h4>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </div>
        <dv>
          <input
            type="checkbox"
            style={{ marginLeft: "5px", marginRight: "5px" }}
          />
          <span>NonHGP</span>
          <input
            type="checkbox"
            style={{ marginLeft: "15px", marginRight: "5px" }}
          />
          <span>NonCurrent</span>
        </dv>
        <div className="padding-15px grid grid-2x grid-mobile-none gap-15px">
          <div className="column-1">
            <SimpleDDL
              box={"search"}
              label={"Rank"}
              options={this.state.kecamatan}
              onChange={(e) => this.onChangeCombo(e, "kecamatan")}
              // disabled={this.props.type === "view" || this.props.type === "edit"}
              value={this.state.data.kecamatan}
            />
          </div>
          <div className="column-2">
            <div className="padding-left-5px padding-right-5px grid-mobile-none gap-15px">
              <div className="margin-bottom-20px">
                <div className="margin-5px">
                  <div className="txt-site txt-11 txt-main txt-bold">
                    <h4>Status</h4>
                  </div>
                </div>
                <div className="margin-bottom-10px">
                  <div className="margin-10px">
                    <label className="radio">
                      <input
                        type="checkbox"
                        disabled={this.props.type === "view"}
                        checked={this.state.data.status === "Active"}
                        onChange={(e) => {
                          this.setState({
                            data: {
                              ...this.state.data,
                              status: e.target.checked
                                ? "Active"
                                : "Non Active",
                            },
                          });
                        }}
                      />
                      <span className="checkmark" />
                      <div className="txt-site txt-11 txt-bold txt-main">
                        <h4>{this.state.data.status}</h4>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderForm2() {
    return (
      <div>
        <SimpleDDL
          box={"search"}
          label={"Supersede Part"}
          options={this.state.kecamatan}
          onChange={(e) => this.onChangeCombo(e, "kecamatan")}
          // disabled={this.props.type === "view" || this.props.type === "edit"}
          value={this.state.data.kecamatan}
        />
        <SimpleDDL
          box={"search"}
          label={"Supplier"}
          options={this.state.provinsi}
          onChange={(e) => this.onChangeCombo(e, "provinsi")}
          // disabled={this.props.type === "view" || this.props.type === "edit"}
          value={this.state.data.provinsi}
        />
        <SimpleDDL
          box={"search"}
          label={"Supplier Name"}
          options={this.state.maindealername}
          onChange={(e) => this.onChangeCombo(e, "maindealername")}
          // disabled={this.props.type === "view" || this.props.type === "edit"}
          value={this.state.data.maindealername}
        />
        <SimpleDDL
          box={"search"}
          label={"Kelompok Barang"}
          options={this.state.provinsi}
          onChange={(e) => this.onChangeCombo(e, "provinsi")}
          // disabled={this.props.type === "view" || this.props.type === "edit"}
          value={this.state.data.provinsi}
        />
        <SimpleDDL
          box={"search"}
          label={"Part Group"}
          options={this.state.provinsi}
          onChange={(e) => this.onChangeCombo(e, "provinsi")}
          // disabled={this.props.type === "view" || this.props.type === "edit"}
          value={this.state.data.provinsi}
        />
        <SimpleDDL
          box={"search"}
          label={"Type"}
          options={this.state.provinsi}
          onChange={(e) => this.onChangeCombo(e, "provinsi")}
          // disabled={this.props.type === "view" || this.props.type === "edit"}
          value={this.state.data.provinsi}
        />
      </div>
    );
  }
  renderForm3() {
    return (
      <div>
        <SimpleDDL
          box={"search"}
          label={"Lifetime"}
          options={this.state.maindealername}
          onChange={(e) => this.onChangeCombo(e, "maindealername")}
          // disabled={this.props.type === "view" || this.props.type === "edit"}
          value={this.state.data.maindealername}
        />
        <SimpleDDL
          box={"search"}
          label={"Status MD"}
          options={this.state.kota}
          onChange={(e) => this.onChangeCombo(e, "kota")}
          // disabled={this.props.type === "view" || this.props.type === "edit"}
          value={this.state.data.kota}
        />

        <div
          style={{
            justifyContent: "center",
            alignContent: "center",
            display: "flex",
            marginTop: "10px",
          }}
        >
          <img
            src={require("../../../../assets/img/upload img.jpg")}
            // alt=""
            style={{ marginRight: 10, width: "360px", height: "230px" }}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginRight: 45,
            marginTop: 20,
          }}
        >
          <button
            className="btn btn-print"
            type="button"
            onClick={this.props.onClickClose.bind(this)}
          >
            <span>Upload Image</span>
          </button>
        </div>
      </div>
    );
  }
}

export default FormPart;
